'use client';

import { Provider } from '@/lib/providers/types';
import { Session } from 'next-auth';
import { AppSidebar } from './appSidebar';
import { SidebarInset, SidebarProvider, SidebarTrigger } from './ui/sidebar';

interface AppLayoutProps {
	providers: Provider[];
	userSession: Session | null;
	userIsAdminOfProvider: boolean;
	children: React.ReactNode;
}

export function AppLayout(props: AppLayoutProps) {
	return (
		<SidebarProvider>
			<AppSidebar
				providers={props.providers}
				userSession={props.userSession}
				userIsAdminOfProvider={props.userIsAdminOfProvider}
			/>
			<SidebarInset>
				<SidebarTrigger className='block md:hidden my-2 mx-4' />
				{props.children}
			</SidebarInset>
		</SidebarProvider>
	);
}
